/* Atelier pick-up-only gate (2026-09-24).
   Shower screens (products tagged `pickup-only`) cannot be delivered. This file makes the
   customer choose a pick-up location BEFORE the screen reaches the cart, and keeps the
   choice on the cart line as a visible property ("Pick-up location"), which Shopify then
   carries into checkout, the order confirmation and the admin order.

   Four entry points, all inert unless a pick-up-only product is involved:
   1. PDP gate: a capture-phase submit listener stops the add-to-cart form when it carries
      the `[data-apk-product]` marker (emitted by snippets/buy-buttons.liquid only for
      pickup-only products), opens the panel, then re-submits the form with the property.
   2. Cart rows: snippets/atelier-pickup-line.liquid renders a row on every pickup-only
      line in the drawer and on /cart; its button opens the panel to set or change the
      location (POST /cart/change.js with the merged properties).
   3. Strays: anything that adds a screen without the panel (finish bloom, wishlist, apps)
      shows up as a line without a location - when one appears in the open drawer the
      panel opens for it straight away.
   4. Checkout: a click on a checkout link while a pickup-only line has no location opens
      the panel for each such line, then continues to /checkout.

   Loaded globally from snippets/atelier-cart.liquid. Styles: assets/atelier-pickup.css.
   Locations are defined ONCE below (LOCS); the PDP notice copy in
   snippets/atelier-pickup.liquid names the same cities - keep the two in step. */
(function () {
  'use strict';
  if (window.__atelierPickup) return;
  window.__atelierPickup = true;

  var PROP = 'Pick-up location';
  var STORE_KEY = 'atelierPickup';

  /* The stylesheet is linked server-side only where it's needed at first paint (screen PDPs,
     carts already holding a screen); everywhere else it's added the first time the panel
     or a pick-up row appears. */
  var CSS_URL = (document.currentScript && document.currentScript.getAttribute('data-css')) || '';
  function ensureCss() {
    if (!CSS_URL || document.querySelector('link[data-apk-css]') || document.querySelector('link[href*="atelier-pickup.css"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = CSS_URL; l.setAttribute('data-apk-css', '');
    document.head.appendChild(l);
  }

  /* value = what the cart, checkout, confirmation email and admin order show */
  var LOCS = [
    { id: 'smithfield', grp: 'own', city: 'Smithfield', st: 'NSW', pin: 'syd',
      sub: '81 Warren Road, Smithfield NSW 2164',
      value: 'Smithfield NSW (81 Warren Road)' },
    { id: 'sydney', grp: 'fz', city: 'Sydney', st: 'NSW', pin: 'syd',
      value: 'Sydney NSW (Fienza warehouse, by arrangement)' },
    { id: 'brisbane', grp: 'fz', city: 'Brisbane', st: 'QLD', pin: 'bne',
      value: 'Brisbane QLD (Fienza warehouse, by arrangement)' },
    { id: 'melbourne', grp: 'fz', city: 'Melbourne', st: 'VIC', pin: 'mel',
      value: 'Melbourne VIC (Fienza warehouse, by arrangement)' },
    { id: 'adelaide', grp: 'fz', city: 'Adelaide', st: 'SA', pin: 'adl',
      value: 'Adelaide SA (Fienza warehouse, by arrangement)' },
    { id: 'perth', grp: 'fz', city: 'Perth', st: 'WA', pin: 'per',
      value: 'Perth WA (Fienza warehouse, by arrangement)' }
  ];
  /* nearest pick-up per state, for the "Nearest to <suburb>" hint only (never pre-selects) */
  var NEAREST = { NSW: 'smithfield', ACT: 'smithfield', VIC: 'melbourne', TAS: 'melbourne',
                  QLD: 'brisbane', SA: 'adelaide', NT: 'adelaide', WA: 'perth' };

  /* Map: Natural Earth 1:50m coastline (world-atlas@2), Australian Albers equal-area conic
     (standard parallels 18S / 36S, central meridian 132E), mainland + Tasmania + Kangaroo
     and Melville Islands, simplified to ~450 points. viewBox 0 0 1000 934.
     Pins are HTML over the SVG, positioned in % of that box (crisp labels at any size). */
  var MAP_H = 934;
  var MAP_D = 'M786 36L783 46 791 55 794 78 792 86 796 104 802 107 816 102 820 110 837 124 835 139 838 156 836 166 844 180 848 181 851 202 847 220 854 228 852 236 854 241 873 255 880 255 887 267 912 285 914 291 910 290 909 293 920 310 922 320 925 324 928 349 931 348 935 353 935 346 939 343 949 355 951 351 953 352 955 357 953 382 959 392 975 404 980 419 988 426 991 438 996 446 996 457 1000 462 996 471 993 496 999 528 998 540 989 556 984 573 975 591 969 615 957 631 953 641 944 647 945 649 936 652 924 668 921 669 919 679 915 680 918 682 907 693 904 708 897 712 887 729 877 756 874 775 863 780 836 778 827 780 802 798 787 798 789 803 792 802 790 810 786 802 781 802 778 795 770 791 773 787 772 783 768 782 760 789 755 784 759 784 765 778 760 772 749 777 754 780 728 794 705 780 689 776 686 779 682 778 673 769 665 767 660 763 647 744 650 728 648 719 632 696 636 695 639 697 639 691 621 697 613 696 622 680 622 672 613 655 603 682 584 684 587 675 596 676 599 654 610 638 609 627 612 625 608 610 608 617 599 627 594 639 575 650 562 667 563 676 559 673 556 675 549 666 544 665 546 662 552 665 547 647 539 637 537 629 533 625 526 624 523 619 521 612 524 611 524 606 511 596 500 596 490 589 477 590 465 582 451 576 443 579 427 579 399 583 361 600 328 602 301 620 290 625 282 642 274 651 267 654 257 652 243 656 240 652 225 652 189 660 185 664 181 672 169 676 153 692 147 695 116 697 103 693 92 684 78 680 75 660 80 663 84 662 87 659 90 649 87 634 88 626 85 606 66 576 55 537 34 509 28 489 7 465 3 459 6 460 6 455 14 468 18 468 20 465 20 461 12 455 6 445 7 441 14 447 16 455 19 452 23 460 26 461 29 458 27 446 1 408 1 392 6 378 5 364 1 357 6 334 9 332 9 335 12 351 17 346 24 330 42 318 54 303 71 291 90 290 109 278 123 273 132 265 145 265 166 257 181 249 189 240 200 216 213 204 210 200 206 185 210 175 220 166 226 156 245 185 244 171 251 174 252 168 241 157 244 154 243 149 247 148 250 153 255 149 262 152 275 152 265 150 265 145 270 144 271 137 270 136 267 140 264 134 265 127 268 127 271 120 282 125 282 121 277 121 275 117 280 112 289 115 290 112 286 110 284 104 286 100 294 97 296 91 298 92 297 98 301 96 303 100 307 97 309 86 307 82 311 83 313 87 317 83 321 87 327 81 327 76 330 75 346 82 366 101 364 118 366 115 369 117 368 108 377 102 391 105 395 112 397 104 402 106 407 112 407 103 412 103 406 98 408 95 399 91 408 79 412 68 423 60 420 56 421 50 425 48 427 43 433 42 433 36 440 39 440 34 444 33 444 30 450 29 452 25 456 31 474 31 479 29 483 32 486 27 492 27 490 25 491 14 485 10 474 9 467 4 471 1 476 4 481 2 491 10 499 7 505 16 525 19 540 26 549 24 557 30 562 31 582 20 576 31 583 29 586 37 591 38 593 34 592 29 600 25 601 30 609 33 611 36 599 48 600 54 596 60 592 57 581 61 583 76 579 85 566 102 567 106 587 120 589 125 600 129 600 133 602 135 608 134 627 145 641 159 662 166 667 178 688 190 693 190 710 183 728 146 730 134 736 119 735 102 737 93 735 83 740 69 740 60 745 56 749 57 748 51 743 47 744 44 750 34 752 36 760 6 769 0 773 1 771 5 776 9 778 17 778 32ZM433 6L444 5 451 1 459 8 456 12 442 22 430 13 426 2 427 1ZM600 699L610 700 610 704 601 704 596 708 591 706 589 707 580 707 576 702 578 698 594 695 600 696ZM755 852L761 852 782 865 791 864 793 867 797 862 807 864 811 860 816 861 819 859 824 862 822 899 819 893 812 908 811 924 807 925 805 922 804 919 808 917 803 914 800 919 798 912 795 924 790 921 791 925 786 934 780 930 769 930 768 925 773 924 766 922 759 912 755 892 760 900 761 896 758 890 756 891 756 886 748 868 746 857 749 848Z';
  var PINS = {"per":[89.7,613.0,"Perth","r"],"adl":[624.0,677.3,"Adelaide","l"],"mel":[762.1,769.4,"Melbourne","b"],"syd":[914.7,676.2,"Sydney","l"],"bne":[989.5,503.6,"Brisbane","l"]};

  var ICON_PIN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11Z"/><circle cx="12" cy="10" r="2.4"/></svg>';
  var ICON_INFO = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v5"/><path d="M12 8h.01"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function locById(id) { for (var i = 0; i < LOCS.length; i++) if (LOCS[i].id === id) return LOCS[i]; return null; }
  function locByValue(v) { for (var i = 0; i < LOCS.length; i++) if (LOCS[i].value === v) return LOCS[i]; return null; }
  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/'; }
  function titleCase(s) { return String(s || '').toLowerCase().replace(/(^|[\s-])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  function savedPlace() {
    try { var v = JSON.parse(lsGet('atelierDeliverTo') || 'null'); if (v && v.st) return v; } catch (e) { /* ignore */ }
    return null;
  }

  /* ------------------------------------------------------------------ panel */
  var root, dlg, goBtn, errEl, lastFocus, prevOverflow, prevPad;
  var S = null;   // open state: { mode, sel, form?, line?, queue? }

  function optHTML(l, near) {
    return '<label class="apk-opt" data-loc="' + l.id + '">' +
      '<input type="radio" name="apk-loc" value="' + l.id + '">' +
      '<span class="apk-o-t">' + esc(l.city) + ' <span class="apk-o-st">' + l.st + '</span></span>' +
      (l.sub ? '<span class="apk-o-s">' + esc(l.sub) + '</span>' : '') +
      (near ? '<span class="apk-near">' + esc(near) + '</span>' : '') +
    '</label>';
  }

  function build() {
    ensureCss();
    if (root) return;
    root = document.createElement('div');
    root.className = 'apk-root';
    root.setAttribute('hidden', '');
    var pins = Object.keys(PINS).map(function (k) {
      var p = PINS[k];
      return '<button type="button" class="apk-pin" tabindex="-1" data-pin="' + k + '" data-lab="' + p[3] + '" style="left:' + (p[0] / 10) + '%;top:' + (p[1] / MAP_H * 100) + '%"><i></i><b>' + p[2] + '</b></button>';
    }).join('');
    root.innerHTML =
      '<div class="apk-scrim" data-apk-x></div>' +
      '<div class="apk-dlg" role="dialog" aria-modal="true" aria-labelledby="apkT" aria-describedby="apkD">' +
        '<button type="button" class="apk-close" data-apk-x aria-label="Close">' + ICON_X + '</button>' +
        '<div class="apk-mapcol">' +
          '<div class="apk-mapbox" aria-hidden="true">' +
            '<svg viewBox="0 0 1000 ' + MAP_H + '" focusable="false">' +
              '<defs><pattern id="apkDots" width="17" height="17" patternUnits="userSpaceOnUse"><circle cx="8.5" cy="8.5" r="2.6"/></pattern></defs>' +
              '<path class="apk-land" d="' + MAP_D + '"/>' +
              '<path class="apk-dots" d="' + MAP_D + '"/>' +
            '</svg>' + pins +
          '</div>' +
          '<div class="apk-sel" aria-live="polite"><span class="apk-sel-k">Collect from</span><b data-apk-sel1>No location chosen</b><small data-apk-sel2></small></div>' +
        '</div>' +
        '<div class="apk-main">' +
          '<div class="apk-scroll">' +
            '<span class="apk-flag">' + ICON_PIN + 'Pick-up only</span>' +
            '<h2 class="apk-h" id="apkT"></h2>' +
            '<p class="apk-p" id="apkD"></p>' +
            '<div class="apk-item" data-apk-item></div>' +
            '<div class="apk-opts" role="radiogroup" aria-labelledby="apkT" data-apk-opts></div>' +
          '</div>' +
          '<div class="apk-foot">' +
            '<p class="apk-fnote">' + ICON_INFO + 'We\'ll contact you to arrange collection.</p>' +
            '<p class="apk-err" role="alert" hidden></p>' +
            '<button type="button" class="apk-go" data-apk-go disabled></button>' +
            '<button type="button" class="apk-cancel" data-apk-x>Cancel</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);
    dlg = $('.apk-dlg', root);
    goBtn = $('[data-apk-go]', root);
    errEl = $('.apk-err', root);

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-apk-x]')) { close(); return; }
      var pin = e.target.closest('.apk-pin');
      if (pin) { pickFromPin(pin.getAttribute('data-pin')); return; }
      if (e.target.closest('[data-apk-go]')) confirm();
    });
    root.addEventListener('change', function (e) {
      if (e.target.name === 'apk-loc') select(e.target.value, true);
    });
    /* hover/focus on an option lights its pin, and a pin lights its option(s) */
    root.addEventListener('mouseover', function (e) {
      var o = e.target.closest('.apk-opt'), p = e.target.closest('.apk-pin');
      hot(o ? (locById(o.getAttribute('data-loc')) || {}).pin : p ? p.getAttribute('data-pin') : null);
    });
    root.addEventListener('mouseleave', function () { hot(null); }, true);
    root.addEventListener('focusin', function (e) {
      var o = e.target.closest('.apk-opt');
      if (o) hot((locById(o.getAttribute('data-loc')) || {}).pin);
    });
  }

  function hot(pinKey) {
    $$('.apk-pin', root).forEach(function (p) { p.classList.toggle('hot', p.getAttribute('data-pin') === pinKey); });
    $$('.apk-opt', root).forEach(function (o) { o.classList.toggle('hot', !!pinKey && (locById(o.getAttribute('data-loc')) || {}).pin === pinKey); });
  }

  function pickFromPin(pinKey) {
    var cur = S && S.sel ? locById(S.sel) : null;
    var ids = LOCS.filter(function (l) { return l.pin === pinKey; }).map(function (l) { return l.id; });
    if (!ids.length) return;
    /* Sydney pin stands for both NSW options - a second click moves between them */
    var next = ids[0];
    if (cur && ids.indexOf(cur.id) > -1) next = ids[(ids.indexOf(cur.id) + 1) % ids.length];
    select(next, true);
    var inp = $('input[value="' + next + '"]', root);
    if (inp) inp.focus({ preventScroll: false });
  }

  function select(id, user) {
    var l = locById(id);
    if (!l || !S) return;
    S.sel = id;
    $$('.apk-opt', root).forEach(function (o) {
      var on = o.getAttribute('data-loc') === id;
      o.classList.toggle('on', on);
      var inp = $('input', o); if (inp) inp.checked = on;
    });
    $$('.apk-pin', root).forEach(function (p) {
      var on = p.getAttribute('data-pin') === l.pin;
      p.classList.toggle('on', on);
      if (on && user) { p.classList.remove('pulse'); void p.offsetWidth; p.classList.add('pulse'); }
    });
    $('[data-apk-sel1]', root).textContent = l.city + ' ' + l.st;
    $('[data-apk-sel2]', root).textContent = l.grp === 'own' ? 'Our warehouse, collect in person' : 'Fienza warehouse, by arrangement';
    root.classList.add('has-sel');
    goBtn.disabled = false;
    goBtn.textContent = goLabel(l);
    errEl.hidden = true;
  }

  function goLabel(l) {
    if (!S) return '';
    if (S.mode === 'pdp') return 'Add to cart \u00b7 Collect in ' + l.city;
    if (S.mode === 'checkout') return (S.queue && S.queue.length > 1) ? 'Collect in ' + l.city + ' \u00b7 Next item' : 'Collect in ' + l.city + ' \u00b7 Checkout';
    return 'Collect in ' + l.city;
  }

  /* opts: { mode:'pdp'|'line'|'checkout', title, meta, img, current } */
  function open(opts) {
    build();
    var place = savedPlace();
    var nearId = place ? NEAREST[String(place.st).toUpperCase()] : null;
    var nearTxt = nearId ? 'Nearest to ' + (place.s ? titleCase(place.s) : place.st) : '';
    var own = LOCS.filter(function (l) { return l.grp === 'own'; });
    var fz = LOCS.filter(function (l) { return l.grp === 'fz'; });
    $('[data-apk-opts]', root).innerHTML =
      '<div class="apk-gh">Our warehouse</div>' +
      own.map(function (l) { return optHTML(l, l.id === nearId ? nearTxt : ''); }).join('') +
      '<div class="apk-gh">Fienza warehouses<small>By arrangement. We\'ll contact you with the address.</small></div>' +
      '<div class="apk-grid">' + fz.map(function (l) { return optHTML(l, l.id === nearId ? nearTxt : ''); }).join('') + '</div>';

    var changing = opts.mode === 'line' && opts.current;
    $('#apkT', root).textContent = changing ? 'Change pick-up location' : 'Where will you collect it?';
    $('#apkD', root).textContent = 'Shower screens can\'t be delivered. Choose where you\'ll collect this one. Anything else in your order is delivered as normal.';
    $('[data-apk-item]', root).innerHTML =
      '<span class="apk-it-img">' + (opts.img ? '<img src="' + esc(opts.img) + '" alt="" width="52" height="52">' : '') + '</span>' +
      '<span class="apk-it-tx"><b>' + esc(opts.title) + '</b>' + (opts.meta ? '<small>' + esc(opts.meta) + '</small>' : '') + '</span>';

    S.sel = null;
    root.classList.remove('has-sel');
    $$('.apk-pin', root).forEach(function (p) { p.classList.remove('on', 'hot', 'pulse'); });
    $('[data-apk-sel1]', root).textContent = 'No location chosen';
    $('[data-apk-sel2]', root).textContent = '';
    goBtn.disabled = true;
    goBtn.textContent = 'Choose a pick-up location';
    errEl.hidden = true;
    root.classList.remove('busy');

    /* pre-select only a choice the customer has already made (current line value, or
       their last pick) - never guess one for them */
    var pre = opts.current ? locByValue(opts.current) : locById(lsGet(STORE_KEY));
    if (pre) select(pre.id, false);

    lastFocus = document.activeElement;
    prevOverflow = document.body.style.overflow;
    prevPad = document.body.style.paddingRight;
    var sw = window.innerWidth - document.documentElement.clientWidth;
    if (sw > 0) document.body.style.paddingRight = sw + 'px';
    document.body.style.overflow = 'hidden';
    root.removeAttribute('hidden');
    void root.offsetWidth;   // commit the hidden->shown frame so the entrance transition runs
    root.classList.add('on');
    var first = $('.apk-opt.on input', root) || $('.apk-opt input', root);
    setTimeout(function () { if (first) first.focus({ preventScroll: true }); }, 60);
  }

  function close(keepState) {
    if (!root || !root.classList.contains('on')) return;
    root.classList.remove('on');
    document.body.style.overflow = prevOverflow || '';
    document.body.style.paddingRight = prevPad || '';
    setTimeout(function () { if (!root.classList.contains('on')) root.setAttribute('hidden', ''); }, 420);
    if (!keepState) {
      var f = lastFocus;
      S = null;
      if (f && f.focus && document.contains(f)) { try { f.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    }
  }

  /* Esc closes the panel only (capture on window beats the drawer's own document listener);
     Tab stays inside the dialog */
  window.addEventListener('keydown', function (e) {
    if (!root || !root.classList.contains('on')) return;
    if (e.key === 'Escape') { e.stopImmediatePropagation(); e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('button:not([disabled]):not([tabindex="-1"]), input[type="radio"]', dlg).filter(function (el) {
      if (el.type === 'radio') return el.checked || !$('input[name="apk-loc"]:checked', dlg) && el === $('input[name="apk-loc"]', dlg);
      return el.offsetParent !== null;
    });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }, true);

  function confirm() {
    if (!S || !S.sel || root.classList.contains('busy')) return;
    var l = locById(S.sel);
    lsSet(STORE_KEY, l.id);
    if (S.mode === 'pdp') return confirmPdp(l);
    return confirmLine(l);
  }

  /* ------------------------------------------------------------ 1. PDP gate */
  function confirmPdp(l) {
    var form = S.form;
    var inp = $('input[data-apk-prop]', form);
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'properties[' + PROP + ']';
      inp.setAttribute('data-apk-prop', '');
      form.appendChild(inp);
    }
    inp.value = l.value;
    close();
    form.__apkPass = true;
    setTimeout(function () { form.__apkPass = false; }, 1000);
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    /* every add handler builds its FormData synchronously inside the submit event,
       so the property can go now - a later plain add can't inherit a stale location */
    inp.remove();
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM' || !form.querySelector('[data-apk-product]')) return;
    if (form.__apkPass) { form.__apkPass = false; return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (S) return;
    var data = {};
    try {
      var host = form.closest('product-form');
      var js = (host && host.parentNode && host.parentNode.querySelector('[data-apk-json]')) || document.querySelector('[data-apk-json]');
      data = JSON.parse(js.textContent);
    } catch (err) { data = {}; }
    var vid = (form.querySelector('[name="id"]') || {}).value;
    var qty = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
    var vt = data.variants && vid ? data.variants[String(vid)] : '';
    S = { mode: 'pdp', form: form };
    open({
      mode: 'pdp',
      title: data.title || '',
      meta: [vt && vt !== 'Default Title' ? vt : '', 'Qty ' + qty].filter(Boolean).join(' \u00b7 '),
      img: data.image || ''
    });
  }, true);

  /* ---------------------------------------------------- 2-4. cart line rows */
  function lineOpts(row, mode) {
    return {
      mode: mode,
      title: row.getAttribute('data-title') || '',
      meta: [row.getAttribute('data-meta'), 'Qty ' + (row.getAttribute('data-qty') || 1)].filter(Boolean).join(' \u00b7 '),
      img: row.getAttribute('data-img') || '',
      current: row.getAttribute('data-value') || ''
    };
  }
  function openLine(row, mode, queue) {
    S = { mode: mode, line: row.getAttribute('data-key'), queue: queue || null };
    open(lineOpts(row, mode === 'checkout' ? 'line' : mode));
    if (mode === 'checkout') { goBtn.textContent = S.sel ? goLabel(locById(S.sel)) : 'Choose a pick-up location'; }
  }

  function cartPage() { return document.querySelector('[data-acp]'); }

  function confirmLine(l) {
    var key = S.line, mode = S.mode, queue = S.queue;
    root.classList.add('busy');
    goBtn.disabled = true;
    goBtn.textContent = 'Saving\u2026';
    var onPage = !!cartPage();
    fetch(rootUrl() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var it = null;
        (cart.items || []).forEach(function (x) { if (x.key === key) it = x; });
        if (!it) throw new Error('line gone');
        var props = {};
        Object.keys(it.properties || {}).forEach(function (k) { props[k] = it.properties[k]; });
        props[PROP] = l.value;
        var body = { id: key, quantity: it.quantity, properties: props };
        if (!onPage) { body.sections = 'atelier-cart'; body.sections_url = location.pathname; }
        return fetch(rootUrl() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); })
      .then(function (res) {
        var rest = (queue || []).filter(function (k) { return k !== key; });
        root.classList.remove('busy');
        if (mode === 'checkout' && !rest.length) { close(true); S = null; window.location.href = rootUrl() + 'checkout'; return; }
        if (mode === 'checkout') {
          /* next line without a location - keys of untouched lines are unchanged, so the
             rows still on screen (drawer re-render or not) resolve them */
          close();
          if (!onPage && typeof window.openAtelierCart === 'function') {
            window.openAtelierCart(res && res.sections ? res.sections['atelier-cart'] : undefined);
          }
          setTimeout(function () {
            var row = document.querySelector('[data-apk-line][data-key="' + rest[0] + '"]');
            if (row) openLine(row, 'checkout', rest);
          }, 480);
          return;
        }
        if (onPage) { close(true); S = null; window.location.reload(); return; }
        close();
        if (typeof window.openAtelierCart === 'function') {
          window.openAtelierCart(res && res.sections ? res.sections['atelier-cart'] : undefined);
        }
      })
      .catch(function (err) {
        console.error('[atelier-pickup] save', err);
        root.classList.remove('busy');
        goBtn.disabled = false;
        goBtn.textContent = goLabel(l);
        errEl.textContent = 'That didn\'t save. Please try again.';
        errEl.hidden = false;
      });
  }

  /* row buttons: set / change the location */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-apk-edit]');
    if (!b) return;
    var row = b.closest('[data-apk-line]');
    if (!row || S) return;
    e.preventDefault();
    openLine(row, 'line');
  });

  /* 4. checkout: every pickup-only line needs a location first */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#AtelierCheckout, [data-acp-checkout], a[href$="/checkout"], button[name="checkout"]');
    if (!a) return;
    var scope = a.closest('#AtelierCart') || a.closest('[data-acp]') || document;
    var missing = $$('[data-apk-line][data-apk-missing]', scope);
    if (!missing.length) return;
    e.preventDefault();
    e.stopPropagation();
    if (S) return;
    openLine(missing[0], 'checkout', missing.map(function (r) { return r.getAttribute('data-key'); }));
  }, true);

  /* 3. strays: a pickup-only line WITHOUT a location that appears while the drawer is open
     (e.g. finish-bloom quick add) gets the panel immediately. Lines present at page load
     are only marked seen - their row button and the checkout check cover them. */
  var seen = {};
  function markSeen() {
    var rows = $$('[data-apk-line]');
    if (rows.length) ensureCss();
    rows.forEach(function (r) { seen[r.getAttribute('data-key')] = 1; });
  }
  function checkStrays() {
    var drawer = document.getElementById('AtelierCart');
    var fresh = $$('[data-apk-line][data-apk-missing]', drawer || document).filter(function (r) { return !seen[r.getAttribute('data-key')]; });
    markSeen();
    if (!fresh.length || S || !drawer || !drawer.classList.contains('on')) return;
    openLine(fresh[0], 'line');
  }
  function watch() {
    markSeen();
    var items = document.querySelector('#AtelierCart [data-ct-items]');
    if (items && window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(checkStrays, 120); })
        .observe(items, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
